export default __webpack_public_path__ + "static/media/tutorial_3.9334208b.svg";